import React, { useCallback } from 'react';
import './FooterPartnerIcon.less';
import { trackClickFooterPartner } from '../../../analytics/events/footer';
import clsx from 'clsx';

interface FooterPartnerIconProps {
    src: string;
    alt: string;
    link: string;
    imgHeight: HTMLImageElement['height'];
    className?: string;
}

export const FooterPartnerIcon = ({ src, alt, link, imgHeight, className }: FooterPartnerIconProps) => {
    const handleClick = useCallback(() => {
        trackClickFooterPartner(alt);
    }, [alt]);

    return (
        <a onClick={handleClick} href={link} rel="noopener noreferrer" target="_blank">
            <img src={src} alt={alt} loading="lazy" height={imgHeight} className={clsx('partners-filter', className)} />
        </a>
    );
};
